var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Heading, Paragraph } from "@riseart/common";
import { profileDetailCardCls, profileDetailCardParagraphCls } from "./Detail.less";
var ProfileDetailCard = /* @__PURE__ */ __name(function ProfileDetailCard2(_ref) {
  var title = _ref.title, born = _ref.born, lives = _ref.lives, bio = _ref.bio, _ref$translations = _ref.translations, translations = _ref$translations === void 0 ? {} : _ref$translations;
  return /* @__PURE__ */ React.createElement("article", {
    className: profileDetailCardCls
  }, title ? /* @__PURE__ */ React.createElement(Heading, {
    tag: "h2"
  }, title) : null, born ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, translations.born), " ", born) : null, lives ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, translations.lives), " ", lives) : null, bio ? /* @__PURE__ */ React.createElement(Paragraph, {
    className: profileDetailCardParagraphCls
  }, bio) : null);
}, "ProfileDetailCard");
export {
  ProfileDetailCard
};
